/**
 * Training list: fetch lessons from /apps/lab9/proxy/lessons with optional
 * server-side filters (level, type, store, device_type) and API pagination (page, per_page).
 * If the API is unavailable, Liquid-rendered content stays.
 */
(function() {
  var PER_PAGE = 50;
  var API_PATH = '/apps/lab9/proxy/lessons';
  var MAX_PAGINATION_LINKS = 5;

  var qs = function(s) { return document.querySelector(s); };
  var qsa = function(s) { return [].slice.call(document.querySelectorAll(s)); };

  var CHECKBOX_SHOP = '.training-filters__checkbox:not(.training-filters__checkbox--title):not(.training-filters__checkbox--device-type):not(.training-filters__checkbox--level)';
  var CHECKBOX_TITLE = '.training-filters__checkbox--title';
  var CHECKBOX_DEVICE_TYPE = '.training-filters__checkbox--device-type';
  var CHECKBOX_LEVEL = '.training-filters__checkbox--level';

  var allItems = [];
  var totalCount = 0;
  var currentPage = 1;
  var apiHost = '';
  var locale = '';
  /** Full filter options (all stores, titles, etc.) so the sidebar stays complete when filters are applied */
  var cachedFilterOpts = null;

  /** Canonical device filter values (URL / API); order shown in sidebar */
  var DEVICE_TYPE_CANONICAL = ['Mac', 'iPad', 'iPhone', 'Apple Watch'];

  /**
   * Expand comma-separated device field into single-device tokens (hyphen compounds become multiple).
   * e.g. "Mac-iPhone-iPad" -> Mac, iPhone, iPad; "Apple Watch" stays one token.
   */
  function expandDeviceTypesFromString(deviceTypesCsv) {
    if (deviceTypesCsv == null || String(deviceTypesCsv).trim() === '') return [];
    var out = [];
    String(deviceTypesCsv).split(',').forEach(function(part) {
      part = part.trim();
      if (!part) return;
      part.split('-').forEach(function(seg) {
        var t = seg.trim();
        if (!t || out.indexOf(t) !== -1) return;
        out.push(t);
      });
    });
    return out;
  }

  /* ── helpers ────────────────────────────────────────── */

  function getTranslations() { return window.trainingTranslations || {}; }

  function getIconArrow() {
    if (window._trainingListIconArrow === undefined) {
      var el = document.getElementById('training-list-icon-arrow');
      window._trainingListIconArrow = el ? el.innerHTML.trim() : '';
    }
    return window._trainingListIconArrow;
  }

  function formatDate(iso) {
    if (!iso) return '';
    // Parse ISO string without timezone conversion
    var match = String(iso).match(/(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})/);
    if (!match) return iso;
    var yyyy = match[1];
    var mm = match[2];
    var dd = match[3];
    var hh = match[4];
    var mi = match[5];
    return dd + '/' + mm + '/' + yyyy + ' ' + hh + ':' + mi;
  }

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  function unique(arr) {
    var seen = {};
    return arr.filter(function(v) {
      if (v == null || v === '') return false;
      var k = String(v);
      if (seen[k]) return false;
      seen[k] = true;
      return true;
    });
  }

  /** Build API URL with optional filters and page. Uses [] so PHP/Laravel receives arrays (e.g. store[]=A&store[]=B). */
  function buildLessonsUrl(filters, page) {
    var p = page != null && page >= 1 ? page : 1;
    var params = new URLSearchParams();
    params.set('locale', locale);
    params.set('page', String(p));
    params.set('per_page', String(PER_PAGE));
    if (filters && filters.level && filters.level.length) filters.level.forEach(function(v) { params.append('level[]', v); });
    if (filters && filters.type && filters.type.length) filters.type.forEach(function(v) { params.append('type[]', v); });
    if (filters && filters.store && filters.store.length) filters.store.forEach(function(v) { params.append('store[]', v); });
    if (filters && filters.device_type && filters.device_type.length) filters.device_type.forEach(function(v) { params.append('deviceType[]', v); });
    return 'https://' + apiHost + API_PATH + '?' + params.toString();
  }

  /** Get current filter state from URL (for initial request before checkboxes exist) */
  function getFiltersFromURL() {
    var params = new URLSearchParams(location.search);
    return {
      level: params.getAll('filter.level'),
      type: params.getAll('filter.title'),
      store: params.getAll('filter.store'),
      device_type: params.getAll('filter.deviceType')
    };
  }

  /** Map checkbox state to API filter param names: shops->store, titles->type, deviceTypes->device_type, levels->level */
  function getFiltersForApi() {
    var f = getSelectedFilters();
    return {
      level: f.levels,
      type: f.titles,
      store: f.shops,
      device_type: f.deviceTypes
    };
  }

  /** Same rules as assets/lesson-slots.js calculateAvailableSlots — keeps list in sync with detail page. */
  function calculateAvailableSlotsFromApiItem(item) {
    if (!item || item.slots == null) return null;
    var totalSlots = Number(item.slots);
    if (isNaN(totalSlots)) return null;
    var bookedSlots = 0;
    if (item.bookings && Array.isArray(item.bookings)) {
      bookedSlots = item.bookings.filter(function(b) { return !b.cancelled_at; }).length;
    } else if (item.bookings_count !== undefined && item.bookings_count !== null) {
      bookedSlots = Number(item.bookings_count);
      if (isNaN(bookedSlots)) bookedSlots = 0;
    } else {
      return null;
    }
    return Math.max(0, totalSlots - bookedSlots);
  }

  /* ── normalise one API item into a flat object ─────── */

  function normalizeItem(item) {
    var isNl = locale === 'NL';
    var lt = item.lesson_type || item.lessonType || {};
    var store = item.store != null ? item.store : (isNl ? item.store_nl : item.store_fr);
    var title = item.title != null ? item.title
      : (isNl ? item.title_nl : item.title_fr)
        || (isNl ? lt.title_nl : lt.title_fr);
    var level = item.level != null ? item.level : lt.level;
    var dt = item.device_types != null ? item.device_types : lt.device_type;
    var deviceTypes = '';
    if (Array.isArray(dt)) deviceTypes = dt.join(',');
    else if (typeof dt === 'string') {
      if (dt.indexOf('[') !== -1) { try { var p = JSON.parse(dt); deviceTypes = Array.isArray(p) ? p.join(',') : dt; } catch(_) { deviceTypes = dt; } }
      else deviceTypes = dt;
    }
    var handle = isNl
      ? (item.shopify_metaobject_handle_nl || item.shopifyMetaobjectHandleNl || lt.shopify_metaobject_handle_nl || lt.shopifyMetaobjectHandleNl)
      : (item.shopify_metaobject_handle_fr || item.shopifyMetaobjectHandleFr || lt.shopify_metaobject_handle_fr || lt.shopifyMetaobjectHandleFr);
    var baseUrl = (typeof location !== 'undefined' && location.origin) ? location.origin : ('https://' + (apiHost || ''));
    // Add locale prefix if present in current URL
    if (typeof location !== 'undefined' && location.pathname) {
      var pathParts = location.pathname.split('/');
      if (pathParts.length > 1 && (pathParts[1] === 'fr' || pathParts[1] === 'nl')) {
        baseUrl += '/' + pathParts[1];
      }
    }
    var url = (handle && String(handle).trim())
      ? (baseUrl + '/pages/training/' + String(handle).trim())
      : (item.url || item.metaobject_url || '');
    var slotsNum = item.slots != null ? Number(item.slots) : null;
    var rawApiCount = item.available_slots_count != null ? item.available_slots_count : item.availableSlotsCount;
    var availableComputed;
    if (rawApiCount !== undefined && rawApiCount !== null && rawApiCount !== '') {
      var parsedApi = Number(rawApiCount);
      availableComputed = (!isNaN(parsedApi) && isFinite(parsedApi)) ? Math.max(0, parsedApi) : calculateAvailableSlotsFromApiItem(item);
    } else {
      availableComputed = calculateAvailableSlotsFromApiItem(item);
    }
    return {
      store: store != null ? String(store) : '',
      title: title != null ? String(title) : '',
      date: item.date || '',
      level: level != null ? String(level) : '',
      device_types: deviceTypes,
      url: url,
      slots: isNaN(slotsNum) ? null : slotsNum,
      has_available_slots: item.has_available_slots,
      available_slots_computed: availableComputed
    };
  }

  /* ── build filter options from all normalised items or from API filters object ── */

  function buildFiltersFromItems(items) {
    var levels = unique(items.map(function(i) { return i.level; })).sort();
    if (levels.length === 0) levels = ['1', '2', '3'];
    var titles = unique(items.map(function(i) { return i.title; })).sort();
    return {
      stores: unique(items.map(function(i) { return i.store; })).sort(),
      titles: titles,
      device_types: DEVICE_TYPE_CANONICAL.slice(),
      levels: levels
    };
  }

  /** Build filter options from raw API items using lessonType.title_fr / title_nl (same as backend type filter). */
  function buildFiltersFromRawItems(rawItems) {
    if (!rawItems || !rawItems.length) return null;
    var isNl = locale === 'NL';
    var titleSet = {};
    var storeSet = {};
    var levelSet = {};
    var dtSet = {};
    rawItems.forEach(function(item) {
      var lt = item.lesson_type || item.lessonType || {};
      var titleVal = isNl ? (lt.title_nl || item.title_nl) : (lt.title_fr || item.title_fr);
      if (titleVal != null && String(titleVal).trim() !== '') titleSet[String(titleVal).trim()] = true;
      [item.store, item.store_fr, item.store_nl].forEach(function(s) {
        if (s != null && String(s).trim() !== '') storeSet[String(s).trim()] = true;
      });
      var l = item.level != null ? item.level : lt.level;
      if (l != null && String(l).trim() !== '') levelSet[String(l).trim()] = true;
      var dt = item.device_types != null ? item.device_types : lt.device_type;
      if (dt != null) {
        var arr = Array.isArray(dt) ? dt : String(dt).split(',').map(function(s) { return s.trim(); });
        arr.forEach(function(d) { if (d) dtSet[d] = true; });
      }
    });
    return {
      stores: Object.keys(storeSet).sort(),
      titles: Object.keys(titleSet).sort(),
      device_types: Object.keys(dtSet).sort(),
      levels: Object.keys(levelSet).length ? Object.keys(levelSet).sort() : ['1', '2', '3']
    };
  }

  /** Build filter options from API response.filters (stores_nl/stores_fr, titles_nl/titles_fr or types_nl/types_fr, device_types, levels) */
  function buildFiltersFromApiResponse(data) {
    var f = (data && data.filters && typeof data.filters === 'object') ? data.filters : (data && data.data && data.data.filters) ? data.data.filters : null;
    if (!f) return null;
    var isNl = locale === 'NL';
    var toArr = function(v) { return Array.isArray(v) ? v : (v != null ? [v] : []); };
    var levels = toArr(f.levels).filter(Boolean).sort();
    if (levels.length === 0) levels = ['1', '2', '3'];
    var titles = toArr(isNl ? (f.titles_nl || f.types_nl || f.type_nl) : (f.titles_fr || f.types_fr || f.type_fr)).filter(Boolean);
    if (titles.length === 0) titles = toArr(isNl ? (f.titles_fr || f.types_fr || f.type_fr) : (f.titles_nl || f.types_nl || f.type_nl)).filter(Boolean);
    if (titles.length === 0) titles = toArr(f.titles || f.types).filter(Boolean);
    return {
      stores: toArr(isNl ? f.stores_nl : f.stores_fr).filter(Boolean).sort(),
      titles: titles.sort(),
      device_types: toArr(f.device_types).filter(Boolean).sort(),
      levels: levels
    };
  }

  /** Merge filter options: prefer API when present, fill missing titles (and others) from raw items. */
  function mergeFilterOptions(apiOpts, rawItems) {
    var canonicalDt = DEVICE_TYPE_CANONICAL.slice();
    var fromRaw = buildFiltersFromRawItems(rawItems);
    if (!fromRaw) {
      if (!apiOpts) return null;
      return {
        stores: apiOpts.stores,
        titles: apiOpts.titles,
        device_types: canonicalDt,
        levels: apiOpts.levels
      };
    }
    if (!apiOpts) {
      return {
        stores: fromRaw.stores,
        titles: fromRaw.titles,
        device_types: canonicalDt,
        levels: fromRaw.levels
      };
    }
    return {
      stores: (apiOpts.stores && apiOpts.stores.length) ? apiOpts.stores : fromRaw.stores,
      titles: (apiOpts.titles && apiOpts.titles.length) ? apiOpts.titles : fromRaw.titles,
      device_types: canonicalDt,
      levels: (apiOpts.levels && apiOpts.levels.length) ? apiOpts.levels : fromRaw.levels
    };
  }

  /* ── filter logic (client-side) ────────────────────── */

  function getSelectedFilters() {
    return {
      shops: qsa(CHECKBOX_SHOP).filter(function(cb) { return cb.checked; }).map(function(cb) { return cb.value; }),
      titles: qsa(CHECKBOX_TITLE).filter(function(cb) { return cb.checked; }).map(function(cb) { return cb.value; }),
      deviceTypes: qsa(CHECKBOX_DEVICE_TYPE).filter(function(cb) { return cb.checked; }).map(function(cb) { return cb.value; }),
      levels: qsa(CHECKBOX_LEVEL).filter(function(cb) { return cb.checked; }).map(function(cb) { return cb.value; })
    };
  }

  function applyFilters() {
    var f = getSelectedFilters();
    var noShop = f.shops.length === 0;
    var noTitle = f.titles.length === 0;
    var noDt = f.deviceTypes.length === 0;
    var noLevel = f.levels.length === 0;
    filteredItems = allItems.filter(function(item) {
      if (!noShop && f.shops.indexOf(item.store) === -1) return false;
      if (!noTitle && f.titles.indexOf(item.title) === -1) return false;
      if (!noLevel && f.levels.indexOf(item.level) === -1) return false;
      if (!noDt) {
        var expanded = expandDeviceTypesFromString(item.device_types);
        var match = false;
        for (var di = 0; di < f.deviceTypes.length; di++) {
          if (expanded.indexOf(f.deviceTypes[di]) !== -1) { match = true; break; }
        }
        if (!match) return false;
      }
      return true;
    });
  }

  /* ── URL <-> checkboxes sync ───────────────────────── */

  function getPageFromURL() {
    var p = parseInt(new URLSearchParams(location.search).get('page'), 10);
    return (p >= 1 && p < 10000) ? p : 1;
  }

  function updateURL(page) {
    var f = getSelectedFilters();
    var url = new URL(location.href);
    url.searchParams.delete('filter.store');
    url.searchParams.delete('filter.title');
    url.searchParams.delete('filter.deviceType');
    url.searchParams.delete('filter.level');
    url.searchParams.delete('page');
    f.shops.forEach(function(s) { url.searchParams.append('filter.store', s); });
    f.titles.forEach(function(t) { url.searchParams.append('filter.title', t); });
    f.deviceTypes.forEach(function(d) { url.searchParams.append('filter.deviceType', d); });
    f.levels.forEach(function(l) { url.searchParams.append('filter.level', l); });
    if (page > 1) url.searchParams.set('page', String(page));
    history.pushState({}, '', url);
  }

  function loadFromURL() {
    var params = new URLSearchParams(location.search);
    var shopP = params.getAll('filter.store');
    var titleP = params.getAll('filter.title');
    var dtP = params.getAll('filter.deviceType');
    var levelP = params.getAll('filter.level');
    qsa(CHECKBOX_SHOP).forEach(function(cb) { cb.checked = shopP.indexOf(cb.value) !== -1; });
    qsa(CHECKBOX_TITLE).forEach(function(cb) { cb.checked = titleP.indexOf(cb.value) !== -1; });
    qsa(CHECKBOX_DEVICE_TYPE).forEach(function(cb) { cb.checked = dtP.indexOf(cb.value) !== -1; });
    qsa(CHECKBOX_LEVEL).forEach(function(cb) { cb.checked = levelP.indexOf(cb.value) !== -1; });
  }

  function toggleClearButton() {
    var f = getSelectedFilters();
    var has = f.shops.length + f.titles.length + f.deviceTypes.length + f.levels.length > 0;
    var btn = qs('#clear-filters-btn');
    if (btn) {
      btn.disabled = !has;
      btn.classList.toggle('training-filters__clear-btn--disabled', !has);
    }
  }

  /* ── render filter checkboxes ──────────────────────── */

  function buildFilterItemHtml(value, type, id, checked, labelOverride) {
    var label = labelOverride != null ? labelOverride : value;
    var cls = type === 'shop'
      ? 'input training-filters__checkbox'
      : 'input training-filters__checkbox training-filters__checkbox--' + (type === 'device_type' ? 'device-type' : type);
    return '<div class="training-filters__item"><div class="checkbox">' +
      '<input type="checkbox" class="' + cls + '" value="' + esc(value) + '" id="' + id + '"' + (checked ? ' checked' : '') + '>' +
      '<label class="label" for="' + id + '">' + esc(label) + '</label></div></div>';
  }

  function renderFilters(opts) {
    var params = new URLSearchParams(location.search);
    var shopP = params.getAll('filter.store');
    var titleP = params.getAll('filter.title');
    var dtP = params.getAll('filter.deviceType');
    var levelP = params.getAll('filter.level');
    var c = 0;

    var shopEl = qs('#training-filters-shop');
    if (shopEl) {
      c = 0;
      shopEl.innerHTML = opts.stores.map(function(s) { c++; return buildFilterItemHtml(s, 'shop', 'filter-shop-' + c, shopP.indexOf(s) !== -1); }).join('');
    }
    var titleEl = qs('#training-filters-title');
    if (titleEl) {
      c = 0;
      titleEl.innerHTML = opts.titles.map(function(t) { c++; return buildFilterItemHtml(t, 'title', 'filter-title-' + c, titleP.indexOf(t) !== -1); }).join('');
    }
    var dtEl = qs('#training-filters-device-type');
    if (dtEl) {
      var t = getTranslations();
      var dtLabel = function(d) {
        if (d === 'Mac') return t.deviceTypeMac || d;
        if (d === 'iPad') return t.deviceTypeIpad || d;
        if (d === 'iPhone') return t.deviceTypeIphone || d;
        if (d === 'Apple Watch') return t.deviceTypeAppleWatch || d;
        return d;
      };
      c = 0;
      dtEl.innerHTML = DEVICE_TYPE_CANONICAL.map(function(d) {
        c++;
        return buildFilterItemHtml(d, 'device_type', 'filter-dt-' + c, dtP.indexOf(d) !== -1, dtLabel(d));
      }).join('');
    }
    var dtSec = qs('#training-filters-device-type-section');
    if (dtSec) dtSec.style.display = DEVICE_TYPE_CANONICAL.length ? '' : 'none';

    var levelEl = qs('#training-filters-level');
    if (levelEl) {
      c = 0;
      levelEl.innerHTML = opts.levels.map(function(l) {
        c++;
        var num = parseInt(l, 10);
        var star = (num >= 1 && num <= 3) ? ('\u2605'.repeat(num) + '\u2606'.repeat(3 - num)) : String(l);
        return buildFilterItemHtml(String(l), 'level', 'filter-level-' + c, levelP.indexOf(String(l)) !== -1, star);
      }).join('');
    }
    var lvlSec = qs('#training-filters-level-section');
    if (lvlSec) lvlSec.style.display = opts.levels.length ? '' : 'none';
  }

  /* ── render rows / cards ───────────────────────────── */

  function buildSlotsCellContent(n) {
    var t = getTranslations();
    var volzet = t.volzet || 'Volzet';
    if (n.available_slots_computed !== null && n.available_slots_computed !== undefined) {
      if (n.available_slots_computed === 0) {
        return '<span class="lesson-slots lesson-slots--from-api lesson-slots--full">' + volzet + '</span>';
      }
      return '<span class="lesson-slots lesson-slots--from-api">' + n.available_slots_computed + '</span>';
    }
    if (n.has_available_slots === false && n.slots != null && n.slots > 0) {
      return '<span class="lesson-slots lesson-slots--from-api">' + n.slots + '</span>';
    }
    if (n.has_available_slots === false) {
      return '<span class="lesson-slots lesson-slots--from-api lesson-slots--full">' + volzet + '</span>';
    }
    if (n.slots != null) return '<span class="lesson-slots lesson-slots--from-api">' + n.slots + '</span>';
    return '<span class="lesson-slots lesson-slots--from-api">-</span>';
  }

  function buildTableRow(n) {
    var t = getTranslations();
    var vd = t.viewDetails || 'View details';
    var hasUrl = n.url && String(n.url).trim() !== '';
    var rowClass = hasUrl ? 'training-table__row--clickable' : 'training-table__row--disabled';
    var hrefAttr = hasUrl ? ' data-href="' + esc(n.url) + '"' : '';
    var titleCell = hasUrl
      ? '<a href="' + esc(n.url) + '">' + esc(n.title) + '</a>'
      : esc(n.title);
    var arrowCell = hasUrl
      ? '<a href="' + esc(n.url) + '" aria-label="' + esc(vd) + '">' + getIconArrow() + '</a>'
      : getIconArrow();
    return '<tr class="' + rowClass + '"' + hrefAttr + ' data-shop="' + esc(n.store) + '" data-title="' + esc(n.title) + '" data-device-type="' + esc(n.device_types) + '" data-level="' + esc(n.level) + '">' +
      '<td>' + formatDate(n.date) + '</td>' +
      '<td>' + titleCell + '</td>' +
      '<td>' + esc(n.store) + '</td>' +
      '<td>' + buildSlotsCellContent(n) + '</td>' +
      '<td>' + arrowCell + '</td></tr>';
  }

  function buildCard(n) {
    var t = getTranslations();
    var hasUrl = n.url && String(n.url).trim() !== '';
    var cardClass = hasUrl ? 'training-card' : 'training-card training-card--disabled';
    var linkHtml = hasUrl
      ? '<a href="' + esc(n.url) + '" class="training-card__link" aria-label="' + esc(n.title) + '"></a>'
      : '';
    return '<div class="' + cardClass + '" data-shop="' + esc(n.store) + '" data-title="' + esc(n.title) + '" data-device-type="' + esc(n.device_types) + '" data-level="' + esc(n.level) + '">' +
      '<div class="training-card__header"><h3 class="training-card__title">' + esc(n.title) + '</h3>' +
      '<div class="training-card__arrow">' + getIconArrow() + '</div></div>' +
      '<div class="training-card__meta">' +
      '<div class="training-card__meta-item"><span class="training-card__meta-label">' + (t.dateLabel || 'Date') + ':</span><span class="training-card__meta-value">' + formatDate(n.date) + '</span></div>' +
      '<div class="training-card__meta-item"><span class="training-card__meta-label">' + (t.storeLabel || 'Store') + ':</span><span class="training-card__meta-value">' + esc(n.store) + '</span></div>' +
      '<div class="training-card__meta-item"><span class="training-card__meta-label">' + (t.slotsLabel || 'Available slots') + ':</span><span class="training-card__meta-value">' +
      buildSlotsCellContent(n) + '</span></div></div>' +
      linkHtml + '</div>';
  }

  function renderList(items) {
    var t = getTranslations();
    var noText = t.noResults || 'No results found. Please try adjusting your filters.';
    var empty = items.length === 0;
    var tbody = qs('#training-table-body');
    if (tbody) tbody.innerHTML = items.map(buildTableRow).join('') +
      '<tr class="training-no-results" id="training-no-results" style="display:' + (empty ? 'table-row' : 'none') + '"><td colspan="5" class="training-no-results__cell"><p>' + noText + '</p></td></tr>';
    var cards = qs('#training-cards-container');
    if (cards) cards.innerHTML = items.map(buildCard).join('') +
      '<div class="training-no-results-mobile" id="training-no-results-mobile" style="display:' + (empty ? 'block' : 'none') + '"><p>' + noText + '</p></div>';
    initClickableRows();
  }

  function initClickableRows() {
    qsa('.training-table__row--clickable[data-href]').forEach(function(row) {
      row.addEventListener('click', function(e) {
        if (e.target.closest('a')) return;
        var href = row.getAttribute('data-href');
        if (href) window.location.href = href;
      });
    });
  }

  /* ── pagination (API-driven) ───────────────────────── */

  function getTotalFromResponse(data) {
    if (data && typeof data.total === 'number') return data.total;
    if (data && data.items && typeof data.items.total === 'number') return data.items.total;
    return 0;
  }

  function getTotalPages() {
    return totalCount <= 0 ? 0 : Math.ceil(totalCount / PER_PAGE);
  }

  function fetchPage(page) {
    var total = getTotalPages();
    if (page < 1) page = 1;
    if (total > 0 && page > total) page = total;
    var url = buildLessonsUrl(getFiltersForApi(), page);
    var paginationEl = qs('#training-load-more-container');
    if (paginationEl) paginationEl.classList.add('training-pagination--loading');
    fetch(url, { method: 'GET', headers: { 'Accept': 'application/json' } })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(data) {
        var raw = getItemsFromResponse(data);
        if (!raw) throw new Error('Invalid response');
        allItems = raw.map(normalizeItem);
        totalCount = getTotalFromResponse(data);
        currentPage = page;
        renderList(allItems);
        updateURL(page);
        renderPagination();
        var wrapper = qs('.training-list-content');
        if (wrapper) wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function(err) {
        console.warn('[Training list] Page fetch failed:', err && err.message ? err.message : err);
      })
      .then(function() {
        if (paginationEl) paginationEl.classList.remove('training-pagination--loading');
      });
  }

  function renderPagination() {
    var container = qs('#training-load-more-container');
    if (!container) return;
    var t = getTranslations();
    var prevText = t.prevPage || 'Previous';
    var nextText = t.nextPage || 'Next';
    var total = getTotalPages();
    if (total <= 0) { container.innerHTML = ''; container.classList.remove('training-pagination-wrapper'); return; }
    var from = Math.max(1, currentPage - Math.floor(MAX_PAGINATION_LINKS / 2));
    var to = Math.min(total, from + MAX_PAGINATION_LINKS - 1);
    var start = Math.max(1, to - MAX_PAGINATION_LINKS + 1);
    var html = '<nav class="training-pagination" aria-label="' + (t.paginationLabel || 'Pagination') + '"><ul class="training-pagination__list">';
    html += '<li class="training-pagination__item">';
    html += currentPage > 1
      ? '<a href="#" class="training-pagination__link training-pagination__link--prev" data-page="' + (currentPage - 1) + '" aria-label="' + esc(prevText) + '">' + esc(prevText) + '</a>'
      : '<span class="training-pagination__link training-pagination__link--disabled">' + esc(prevText) + '</span>';
    html += '</li>';
    for (var i = start; i <= to; i++) {
      html += '<li class="training-pagination__item">';
      html += i === currentPage
        ? '<span class="training-pagination__link training-pagination__link--current" aria-current="page">' + i + '</span>'
        : '<a href="#" class="training-pagination__link" data-page="' + i + '">' + i + '</a>';
      html += '</li>';
    }
    html += '<li class="training-pagination__item">';
    html += currentPage < total
      ? '<a href="#" class="training-pagination__link training-pagination__link--next" data-page="' + (currentPage + 1) + '" aria-label="' + esc(nextText) + '">' + esc(nextText) + '</a>'
      : '<span class="training-pagination__link training-pagination__link--disabled">' + esc(nextText) + '</span>';
    html += '</li></ul></nav>';
    container.innerHTML = html;
    container.classList.add('training-pagination-wrapper');
    container.querySelectorAll('.training-pagination__link[data-page]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var p = parseInt(link.getAttribute('data-page'), 10);
        if (p >= 1) fetchPage(p);
      });
    });
  }

  /* ── wire filters ──────────────────────────────────── */

  function onFilterChange() {
    updateURL(1);
    refetchWithFilters();
  }

  function refetchWithFilters() {
    var url = buildLessonsUrl(getFiltersForApi(), 1);
    var paginationEl = qs('#training-load-more-container');
    if (paginationEl) paginationEl.classList.add('training-pagination--loading');
    fetch(url, { method: 'GET', headers: { 'Accept': 'application/json' } })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(data) {
        var raw = getItemsFromResponse(data);
        if (!raw) throw new Error('Invalid response');
        allItems = raw.map(normalizeItem);
        totalCount = getTotalFromResponse(data);
        currentPage = 1;
        renderFilters(cachedFilterOpts);
        loadFromURL();
        renderList(allItems);
        updateURL(1);
        renderPagination();
        toggleClearButton();
        attachFilterListeners();
      })
      .catch(function(err) {
        console.warn('[Training list] Filter refetch failed:', err && err.message ? err.message : err);
        toggleClearButton();
      })
      .then(function() {
        if (paginationEl) paginationEl.classList.remove('training-pagination--loading');
      });
  }

  function attachFilterListeners() {
    qsa('.training-filters__checkbox').forEach(function(cb) {
      cb.addEventListener('change', onFilterChange);
    });
  }

  function attachClearButtonListener() {
    var clearBtn = qs('#clear-filters-btn');
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        qsa('.training-filters__checkbox').forEach(function(cb) { cb.checked = false; });
        onFilterChange();
      });
    }
  }

  /* ── extract items from API response ───────────────── */

  function getItemsFromResponse(data) {
    if (!data || typeof data !== 'object') return null;
    if (Array.isArray(data.items)) return data.items;
    if (data.items && Array.isArray(data.items.data)) return data.items.data;
    if (Array.isArray(data.data)) return data.data;
    return null;
  }

  /* ── init: fetch first page with optional URL filter params, API pagination ─ */

  function init() {
    var container = qs('.page-training-list');
    if (!container) return;
    locale = (container.getAttribute('data-locale') || '').toUpperCase();
    apiHost = container.getAttribute('data-trainings-api') || location.host;
    if (!locale) return;

    var unfilteredUrl = buildLessonsUrl({}, 1);
    fetch(unfilteredUrl, { method: 'GET', headers: { 'Accept': 'application/json' } })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(data) {
        var raw = getItemsFromResponse(data);
        if (!raw) throw new Error('Invalid response');
        allItems = raw.map(normalizeItem);
        totalCount = getTotalFromResponse(data);
        currentPage = 1;
        var apiFilterOpts = buildFiltersFromApiResponse(data);
        var filterOpts = mergeFilterOptions(apiFilterOpts, raw) || buildFiltersFromItems(allItems);
        cachedFilterOpts = filterOpts;
        renderFilters(filterOpts);
        loadFromURL();
        renderList(allItems);
        renderPagination();
        toggleClearButton();
        attachFilterListeners();
        attachClearButtonListener();
        window.trainingListApiMode = true;
        console.log('[Training list] Loaded page 1, ' + allItems.length + ' items, ' + totalCount + ' total (API pagination)');

        var urlFilters = getFiltersFromURL();
        var hasUrlFilters = urlFilters.store.length || urlFilters.type.length || urlFilters.device_type.length || urlFilters.level.length;
        if (hasUrlFilters) {
          refetchWithFilters();
        } else {
          updateURL(currentPage);
        }

        window.addEventListener('popstate', function() {
          loadFromURL();
          refetchWithFilters();
        });
      })
      .catch(function(err) {
        console.warn('[Training list] API failed, keeping Liquid list:', err && err.message ? err.message : err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
